export default __webpack_public_path__ + "static/media/selected.c12a7dc6.svg";